export const aboutEyePriority = {
  uz: {
    aboutEyePriorityTitle: "Bizning tajriba va yutuqlarimiz",
    aboutEyePriorityText:
      "Klinika tarkib topgandan buyon hozirga qadar ko’z kasalliklarining turli yo’nalishlarda faoliyat olib borayotgan 10 ortiq yuqori malakaki vrachlarni shakillantirdi. Hozirgi kunda klinikada turli ko’z kasalliklarini davolashning 25 dan ortiq mikroinvaziv turli jarrohlik usullari yo’lga qo’yilgan. ",
    aboutEyePriorityText2:
      "Klinikada bajariladigan barcha murakkab jarrohlik amaliyotlari dunyodagi, oftalmologiya sferasida nom qozongan, etakchi  ishlab chiqaruvchi Alcon (AQSH), Carl Zeiss (Germaniya), SCHWIND (Germaniya), Heidelberg engineering (Germaniya) kabi firmalarga tegishli zamonaviy uskunalarda bajariladi.",
    aboutEyePriorityDNA: "Tibbiy Tajriba",
    aboutEyePriorityEYE: "Ko'rish Qobiliyatini Asrash",
    aboutEyePriority20PLUS:
      "Men kulishni xohlardim, lekin men bundan nafratlanardim. Boshlang'ich terapevt",
    aboutEyePriority300PLUS:
      "Homiladorlikning klinik va raqobatbardosh ehtimoli juda muhimdir",
    aboutEyePriorityBtn: "Konsultatsiya olish",
  },
  ru: {
    aboutEyePriorityTitle: "Наш опыт и достижения",
    aboutEyePriorityText:
      "С момента основания клиника сформировала команду из более чем 10 высококвалифицированных врачей, специализирующихся на различных направлениях офтальмологии. На сегодняшний день в клинике внедрено свыше 25 микроинвазивных хирургических методов лечения различных заболеваний глаз.",
    aboutEyePriorityText2:
      "Все сложные хирургические операции в клинике выполняются на современном оборудовании мировых лидеров офтальмологии: американской компании Alcon, немецких Carl Zeiss, SCHWIND, Heidelberg Engineering и других ведущих производителей.",
    aboutEyePriorityDNA: "Медицинский Опыт",
    aboutEyePriorityEYE: "Сохранение Вашего Зрения",
    aboutEyePriority20PLUS:
      "Мне хотелось рассмеяться, но я ненавидел это. Элементарный терапевт",
    aboutEyePriority300PLUS:
      "Клиническая и конкурентная вероятность наступления беременности имеет важное значение",
    aboutEyePriorityBtn: "Получить консультацию",
  },
  tj: {
    aboutEyePriorityTitle: "Наш опыт и достижения",
    aboutEyePriorityText:
      "Ин як истироҳати шавқовар барои иҷрои вазифаи хонагӣ аст. Ҳоло ман табиби амалкунанда ҳастам, аммо ман ҳамшираи арзанда ҳастам",
    aboutEyePriorityText2:
      "Все сложные хирургические операции в клинике выполняются на современном оборудовании мировых лидеров офтальмологии: американской компании Alcon, немецких Carl Zeiss, SCHWIND, Heidelberg Engineering и других ведущих производителей.",
    aboutEyePriorityDNA: "Таҷрибаи Тиббӣ",
    aboutEyePriorityEYE: "Нигоҳ Доштани Биниши Худ",
    aboutEyePriority20PLUS:
      "Ман мехостам хандам, аммо ман аз он нафрат доштам. Терапевти ибтидоӣ",
    aboutEyePriority300PLUS:
      "Эҳтимолияти клиникӣ ва рақобатпазирии ҳомиладорӣ муҳим аст",
    aboutEyePriorityBtn: "Машварат гиред",
  },
};
